import React from 'react'
import testClock from "../../Assets/testclock.png"
import { BiPlus } from 'react-icons/bi'

const BillingTestclock = () => {
    return (
        <div>
            <div className='p-[64px]'>
                <div className='text-center'>
                    <h1 className='text-[#414552] text-[20px] font-bold'>Simulate billing scenarios through time</h1>
                    <p className='text-[#687385] text-[14px] max-w-[320px] mx-auto mt-3'>Simplify testing and check that your integration will work exactly as you expected.</p>
                    <div className='my-5 max-w-[912px] w-full mx-auto'>
                        <img src={testClock} alt="test-clock" />
                    </div>
                    <div className='flex gap-4 flex-col items-center justify-center text-sm my-4'>
                        <button className='flex gap-1 mt-2 text-white font-semibold h-[30px] bg-[#635bff] rounded-[6px] sm:text-[14px] text-[12px] items-center p-[4px_8px]'>
                            <BiPlus className='text-[18px]' />New simulation
                        </button>
                        <button className='text-[#625afa] font-semibold'>Learn about text clocks</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BillingTestclock